export default function TestNullOrReturn(value, edge) {
  if (value === null || value === undefined) {
    return edge;
  } else {
    return value;
  }
}

function isEmptyOrSpaces(str) {
  return str === null || str.match(/^ *$/) !== null;
}

export function v(field, value) {
  if (value && !isEmptyOrSpaces(value.toString())) {
    return {
      [field]: value
    };
  } else {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/helpers/TestNullOrReturn.js